import React from "react";
import { Button } from "primereact/button";

export default function PrimaryButton({
  label = "Submit",
  extraClassNames,
  loading = false,
  onClick,
  icon,
  ...props
}) {
  return (
    <Button
      className={`primary-button align-center px-4 py-3 w-full border-none border-round-xl ${extraClassNames}`}
      label={label}
      style={{ alignSelf: "center" }}
      size="medium"
      onClick={onClick}
      loading={loading}
      icon={icon}
      {...props}
    />
  );
}

export const OutlinedButton = ({ label, extraClassNames,onClick, ...props }) => {
  return (
    <Button
      className={`primary-color border-red-600 align-center oulined-btn border-round-xl ${extraClassNames ? extraClassNames : 'px-4 py-3 w-full'}`}
      label={label}
      onClick={onClick}
      style={{ alignSelf: "center" }}
      size="medium"
      outlined
      {...props}
    />
  );
};


export const ChatButton = ({
  extraClassNames,
  loading = false,
  onClick,
  icon,
  style,
  ...props
}) => {
  return (
    <Button
      className={`primary-button flex justify-content-center align-items-center border-red-600 align-center ${extraClassNames}`}
      style={style}
      size="medium"
      onClick={onClick}
      loading={loading}
      icon={icon}
      {...props}
    ></Button>
  );
}